(() => {
  function getTimePartsInTimeZone(timeZone) {
    const dtf = new Intl.DateTimeFormat("en-US", {
      timeZone,
      weekday: "short",
      hour: "2-digit",
      hourCycle: "h23",
    });
    const parts = dtf.formatToParts(new Date());
    const map = Object.create(null);
    for (const p of parts) {
      if (p.type !== "literal") map[p.type] = p.value;
    }
    return {
      weekday: map.weekday,
      hour: Number.parseInt(map.hour, 10),
    };
  }

  function shouldHideBySchedule(widget) {
    if (widget.dataset.hideWhenOffline !== "true") return false;

    const timeZone = widget.dataset.timeZone || "Europe/Madrid";
    const openHour = Number.parseInt(widget.dataset.openHour || "9", 10);
    const closeHour = Number.parseInt(widget.dataset.closeHour || "18", 10);
    const closeHourFri = Number.parseInt(widget.dataset.closeHourFri || "13", 10);

    let parts;
    try {
      parts = getTimePartsInTimeZone(timeZone);
    } catch (_e) {
      const now = new Date();
      parts = {
        weekday: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][now.getDay()],
        hour: now.getHours(),
      };
    }

    // Horario de atención (hora de Madrid): lunes-jueves de openHour a closeHour,
    // viernes de openHour a closeHourFri. Fuera de eso (y sábado/domingo) no se muestra.
    if (parts.weekday === "Sat" || parts.weekday === "Sun") return true;
    const close = parts.weekday === "Fri" ? closeHourFri : closeHour;
    return parts.hour < openHour || parts.hour >= close;
  }

  function init(widget) {
    const panel = widget.querySelector(".wa-widget__panel");
    const toggle = widget.querySelector(".wa-widget__toggle");
    if (!panel || !toggle) return;

    if (shouldHideBySchedule(widget)) {
      widget.remove();
      return;
    }

    const revealWidget = () => {
      widget.hidden = false;
    };

    const revealWhenStylesReady = () => {
      const styles = document.getElementById("whatsapp-widget-css");
      if (!styles || styles.media !== "print") {
        revealWidget();
        return;
      }

      styles.addEventListener("load", revealWidget, { once: true });
      setTimeout(revealWidget, 1500);
    };

    const loadDeferredImages = () => {
      widget.querySelectorAll("img[data-wa-src]").forEach((img) => {
        img.src = img.dataset.waSrc;
        img.removeAttribute("data-wa-src");
      });
    };

    const setOpen = (open) => {
      if (open && window.matchMedia("(min-width: 769px)").matches) {
        loadDeferredImages();
      }
      widget.classList.toggle("is-open", open);
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    const toggleOpen = () => setOpen(!widget.classList.contains("is-open"));

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      toggleOpen();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (!widget.classList.contains("is-open")) return;
      setOpen(false);
      toggle.focus();
    });

    // Click outside to close.
    document.addEventListener("click", (e) => {
      if (!widget.classList.contains("is-open")) return;
      if (widget.contains(e.target)) return;
      setOpen(false);
    });

    // Start closed.
    setOpen(false);
    revealWhenStylesReady();
  }

  const initAll = () => {
    document.querySelectorAll("[data-whatsapp-widget]").forEach((el) => init(el));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
